import { withoutFilterPresentationState } from "@common/components/filterBar/filterPinning";

export const MAX_BULK_SELECTION = 100;

type HeaderCheckBoxState = "true" | "false" | "indeterminate";

export function toggleSelected(selectedIds: ReadonlySet<string>, id: string): Set<string> {
    const next = new Set(selectedIds);
    if (next.has(id)) {
        next.delete(id);
    } else {
        next.add(id);
    }
    return next;
}

export function setSelectedOnPage(selectedIds: ReadonlySet<string>, pageIds: Array<string>, checked: boolean): Set<string> {
    const next = new Set(selectedIds);
    if (checked) {
        pageIds.forEach((id) => next.add(id));
    } else {
        pageIds.forEach((id) => next.delete(id));
    }
    return next;
}

// Judged by the current page only: the selection is kept across pages, so a page whose rows are all selected
// shows a checked header even when rows on other pages are selected too.
export function getHeaderCheckBoxState(selectedIds: ReadonlySet<string>, pageIds: Array<string>): HeaderCheckBoxState {
    const selectedOnPage = pageIds.filter((id) => selectedIds.has(id)).length;
    if (selectedOnPage === 0) {
        return "false";
    }
    return selectedOnPage === pageIds.length ? "true" : "indeterminate";
}

// Paging and sorting only move rows between pages, so they leave the selection alone. Anything else in the filter
// changes which rows the list shows, and a selection that outlived it would act on rows the user can no longer see.
export function getRowFilterKey(filter: object | undefined): string {
    return JSON.stringify({
        ...withoutFilterPresentationState(filter),
        pageNumber: undefined,
        pageSize: undefined,
        sortByColumn: undefined,
        sortByCustomFieldId: undefined,
        sortDirection: undefined,
    });
}
